
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/llm-info",
      function () {
        return require("private-next-pages/llm-info.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/llm-info"])
      });
    }
  